// What KIND of partner a partner link is (ART-239, 918). The server owns the vocabulary — a CHECK constraint and the
// set gate both refuse anything else — and this is the one place a key becomes words, so the Partner card, the
// profile and the guest list cannot spell one differently.

export const PARTNER_RELATIONSHIPS = [
  { value: "spouse", label: "Spouse" },
  { value: "partner", label: "Partner" },
  { value: "fiancee", label: "Fiancée" },
  { value: "girlfriend", label: "Girlfriend" },
  { value: "boyfriend", label: "Boyfriend" },
  { value: "other", label: "Other" },
] as const;

/** The words a DISPLAY shows for a relationship key — the Partner card's sub-line, the profile's "Fiancée · Jo Park",
 *  the guest-list tag. Null for none, for a key this client does not know (never the raw key), and for `other`, which
 *  is a choice and not a word worth printing ("Other · Jo Park"): those surfaces then say "Partner" or nothing. */
export function partnerRelationshipLabel(key: string | null | undefined): string | null {
  if (key === "other") return null;
  return PARTNER_RELATIONSHIPS.find((r) => r.value === key)?.label ?? null;
}
